import React from "react";
import Walking from "./walking.svg";

function WalkingIcon() {
  return <img src={Walking} alt="walking icon" />;
}

export default WalkingIcon;
